module.exports = __webpack_public_path__ + "img/algorithm.28f25e4b.svg";